import { render, staticRenderFns } from "./ExpressCar.vue?vue&type=template&id=32dc96ea&scoped=true&"
import script from "./ExpressCar.vue?vue&type=script&lang=js&"
export * from "./ExpressCar.vue?vue&type=script&lang=js&"
import style0 from "./ExpressCar.vue?vue&type=style&index=0&id=32dc96ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32dc96ea",
  null
  
)

export default component.exports